module.exports = __webpack_public_path__ + "static/mobby-b88647000617ef8224ed821c718658b1.svg";